import dictionary from './dictionary.json.js';
const config = {
    resource: 'next-footer',
    dictionary,
};
export default config;
//# sourceMappingURL=config.js.map